import React from "react"
import HAbout from "./HAbout"
import Hero from "./hero/Hero"
import SEO from "../common/SEO"
import HomeBackground from "./HomeBackground"
import HomeExperts from "./HomeExperts"
import HomeAccreditation from "./HomeAccreditation"
import Testimonal from "./testimonal/Testimonal"
import "./Home.css"

const Home = () => {
  return (
    <div className="home-wrapper">
      <HomeBackground />
      <SEO
        title="Leading International Education Consultancy"
        description="WELSH EDUCATION GROUP is a premier education consultancy helping students achieve their international education dreams. Expert visa assistance, career counseling, test preparation, and comprehensive study abroad services."
        keywords="international education, study abroad, visa assistance, career counseling, test preparation, IELTS, TOEFL, university admission, student visa, education consultancy"
        url="/"
      />
      <Hero />
      <div className="home-sections">
        <HAbout />
        <HomeExperts />
        <HomeAccreditation />
        <Testimonal />
      </div>
    </div>
  )
}


export default Home
